import { useMutation } from '@tanstack/react-query';

import { AuthInput, requestsClient } from '@/shared/api';

export const useSignIn = () => {
  return useMutation({
    mutationFn: (input: AuthInput) => {
      return requestsClient.signInV2({ input });
    },
  });
};
